import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Chart from 'react-apexcharts';
import { Box } from '@mui/material';

import { getHrState } from '../../../../../store/selector/hr.selector';

const TopReasonsChart = () => {
  const {
    dashboard_list: {
      ApplicationsReport: {
        counts: { Top3Reasons },
      },
    },
  } = useSelector(getHrState);

  const [chartData, setChartData] = useState<ApexAxisChartSeries>([]);

  useEffect(() => {
    const sortedKeys = Object.keys(Top3Reasons).sort();
    const sortedReasons: { [key: string]: number } = {};
    for (const key of sortedKeys) {
      sortedReasons[key] = Top3Reasons[key];
    }

    const newData = Object.entries(sortedReasons).map(([k, v]) => ({
      name: k,
      data: [v as number],
    }));

    setChartData(newData);
  }, []);

  const options: any = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['As of Today'],
    },

    fill: {
      opacity: 1,
      colors: ['#02004D', '#359D78', '#F9AE2C'],
    },
    legend: {
      show: false,
      position: 'left',
      markers: {
        fillColors: ['#359D78', '#02004D', '#F9AE2C'],
      },
    },
  };

  return (
    <Box className='mixed-chart' sx={{ width: '100%' }}>
      <Chart options={options} series={chartData} type='bar' height={300} />
    </Box>
  );
};

export default TopReasonsChart;
